import {useState} from 'react';
import Modal from '@mui/material/Modal';
import CreateTeamForm from '@CommonForms/CreateTeamForm';
import './AddTeamForm.scss';

export default function AddTeamForm(props) {

    const className = 'addTeamForm';

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}>
            <div className={className}>
                <div className={className + '__inner'}>
                    <div className={className + '__create'}>
                        <CreateTeamForm
                            closePopup={props.closePopup}
                            orgId={props.orgId}
                            reloadData={props.reloadData}/>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
